import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRequestState } from "./types";
import { IRequest } from "../../../services/origin/requestApi/types";

export const requestInitialState: IRequestState = {
  request: undefined,
};

const requestSlice = createSlice({
  name: "request",
  initialState: requestInitialState,
  reducers: {
    selectRequestItem: (state, action: PayloadAction<IRequest | undefined>) => {
      state.request = action.payload;
    },
    clearRequestItem: (state) => {
      state.request = undefined;
    },
  },
});

export const { selectRequestItem, clearRequestItem } = requestSlice.actions;
export default requestSlice.reducer;
